module.exports = __webpack_public_path__ + "media/logos/logo-eb540298.png";